import { el, mount } from 'redom'
import { getGoogleApi } from '../../util/googleApis'

let geocoder

export default class MapLocationSelector {
	constructor(options) {
		this.el = el('div.mapLocationSelector')
		this.options = options

		getGoogleApi().then(() => {
			setTimeout(() => {
				// Wait until this.el is in DOM.
				this.initMap()
				mount(
					this.el,
					el('img.mapLocationCenterPin', {
						src: options.centerPinImageUrl || '/common/components/map-location-selector-pin.png',
					})
				)
			}, 0)
		})
	}

	initMap() {
		let { zoom, latitude, longitude, bounds, centerChanged } = this.options

		if (latitude != null && longitude != null && bounds) {
			throw new Error('Only give latitude & longitude or bounds, but not both.')
		}

		this.map = new window.google.maps.Map(this.el, {
			center: { lat: latitude || 0, lng: longitude || 0 },
			zoom: zoom || 16,
			styles,
			scrollwheel: false,
			streetViewControl: false,
			fullscreenControl: false,
		})

		if (bounds) {
			this.map.fitBounds({
				north: bounds.maxLatitude,
				south: bounds.minLatitude,
				west: bounds.minLongitude,
				east: bounds.maxLongitude,
			})
		}

		this.map.addListener('center_changed', () => {
			let center = this.map.getCenter()
			if (centerChanged) centerChanged(center.lat(), center.lng() % 360)
		})
	}

	search(address, callback) {
		if (!geocoder) geocoder = new window.google.maps.Geocoder()

		let self = this

		geocoder.geocode(
			{
				address,
			},
			function(results, status) {
				if (status === 'OK') {
					let location = results[0].geometry.location
					self.setCenter(location.lat(), location.lng())
					self.map.setZoom(15)

					if (callback) callback(results[0])
				} else {
					console.log('Geocoder fail:', status)
				}
			}
		)
	}

	setCenter(latitude, longitude) {
		if (!this.map) {
			console.log('ERROR: setCenter() called too early')
			return
		}
		this.map.setCenter({ lat: latitude, lng: longitude })
	}
}

// The same as mapStylesForProvider in main ResQ project - some day these two
// might share the same code.
//
// Styles for partner and enterprise:
//
// - transit markers removed
// - points of interest de-emphasized slightly (so that the partner can align their location with
//   their own, or other venues on Google Maps)
let styles = [
	{
		featureType: 'poi',
		elementType: 'labels.icon',
		stylers: [
			{
				saturation: -10,
			},
			{
				lightness: 40,
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'labels.text',
		stylers: [
			{
				saturation: -10,
			},
			{
				lightness: 40,
			},
		],
	},
	{
		featureType: 'transit',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
]
